module.exports = __webpack_public_path__ + "static/media/FullFolder.b94c13a7.svg";